 TWO.inc = function (n) {
   return n + 1;
 };